import { AiFillCaretLeft } from "react-icons/ai"; 
import { BiSave } from "react-icons/bi"; 
import CxIcon from '../../cx/CxIcon';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import CxTime from '../../cx/CxTime';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';


const MxSettCalendarWorkingHours = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  const r_snack_save = React.useRef(null);
  const r_snack_required = React.useRef(null);

  let r_form = React.useRef(null);

  const rf_txStartHour = React.useRef(null);
  const rf_txWorkTime1From = React.useRef(null);
  const rf_txWorkTime1To = React.useRef(null);
  const rf_txWorkTime2From = React.useRef(null);
  const rf_txWorkTime2To = React.useRef(null);


  React.useEffect(() => {
    formLoadCustom();
    // eslint-disable-next-line
  }, []);

  const formLoadCustom = async () => {
    let record = {};
    Promise.all([FxFetch.doJsonX('cal/sett', record)]).then((result) => {
      const data = result[0]; // Simplificamos el acceso
      if (data) {
        // Usamos ?? "" para asegurar que siempre sea un string, no undefined
        rf_txStartHour.current.setVal(data.txStartHour ?? "");
        rf_txWorkTime1From.current.setVal(data.txWorkTime1From ?? "");
        rf_txWorkTime1To.current.setVal(data.txWorkTime1To ?? "");
        rf_txWorkTime2From.current.setVal(data.txWorkTime2From ?? "");
        rf_txWorkTime2To.current.setVal(data.txWorkTime2To ?? "");
      }
    });
  }

  const formSaveCustom = async () => {

    if (rf_txStartHour.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txStartHour.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txWorkTime1From.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txWorkTime1From.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txWorkTime1To.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txWorkTime1To.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txWorkTime2From.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txWorkTime2From.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txWorkTime2To.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txWorkTime2To.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    let record = {};
    record['txStartHour'] = rf_txStartHour.current.getVal();
    record['txWorkTime1From'] = rf_txWorkTime1From.current.getVal();
    record['txWorkTime1To'] = rf_txWorkTime1To.current.getVal();
    record['txWorkTime2From'] = rf_txWorkTime2From.current.getVal();
    record['txWorkTime2To'] = rf_txWorkTime2To.current.getVal();
    Promise.all([FxFetch.doJsonF("sett/cal/working_hours/u", null, record)]).then((result) => {
      if (result[0]) {
        if (result[0].theValue === 'OK') {
          r_snack_save.current.setOpen(true);
        }
      }
    });

    r_snack_save.current.setOpen(true);
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.calendars')} - ${trans('field.working_hours')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} frontIcon={<AiFillCaretLeft/>} />} classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save_and_exit')} />
          </div>
        }
      >
        <CxTime xref={rf_txStartHour} label={trans('field.hour') + ' ' + trans('field.start')} required />
        <CxTime xref={rf_txWorkTime1From} label={trans('field.hour_morning_start')} required />
        <CxTime xref={rf_txWorkTime1To} label={trans('field.hour_morning_end')} required />
        <CxTime xref={rf_txWorkTime2From} label={trans('field.hour_afternoon_start')} required />
        <CxTime xref={rf_txWorkTime2To} label={trans('field.hour_afternoon_end')} required />

      </GxForm>

      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} onClose={() => navBack()} />
      <CxSnackbar xref={r_snack_required} severity="error" />

    </div>
  );

}

export default MxSettCalendarWorkingHours;
